import { render, staticRenderFns } from "./documentsComponent.vue?vue&type=template&id=34d7751e&scoped=true&"
import script from "./documentsComponent.vue?vue&type=script&lang=js&"
export * from "./documentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./documentsComponent.vue?vue&type=style&index=0&id=34d7751e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7751e",
  null
  
)

export default component.exports